const hasEmojis = ({ message, value }: { message: string; value: string }) => {
  if (value?.match(/(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu)) return message;
};

const DISABLE_AUTOFILL_PROPERTIES = {
  autoComplete: 'off', // Generic autocomplete off
  'data-1p-ignore': '', // OnePassword
  'data-lpignore': 'true', // LastPass
  'data-protonpass-ignore': 'true', // ProtonPass
  'data-bwignore': 'true', // BitWarden
  'data-keeper-lock': 'false', // Keeper
  'data-form-type': 'other', // Dashlane
};

const getDisableAutofillProps = (shouldDisableAutofill?: boolean) => {
  return shouldDisableAutofill ? DISABLE_AUTOFILL_PROPERTIES : {};
};

export { getDisableAutofillProps, hasEmojis };
